import { createSelector } from 'reselect';

const getTz = (state) => state?.config.localTimezone;
    
export const getLocalTimezone = createSelector(
    [getTz],
    (localTimezone) => localTimezone
);